import "phoenix_html"

import {Socket} from "phoenix";
import {LiveSocket} from "phoenix_live_view";
import topbar from "../vendor/topbar";
import flatpickr from '../vendor/flatpickr-4.6.13.min';
import ApexCharts from 'apexcharts';

window.ApexCharts = ApexCharts;

let csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content")
let liveSocket = new LiveSocket("/live", Socket, {params: {_csrf_token: csrfToken}})

// Show progress bar on live navigation and form submits
topbar.config({barColors: {0: "#29d"}, shadowColor: "rgba(0, 0, 0, .3)"})
window.addEventListener("phx:page-loading-start", info => topbar.show())
window.addEventListener("phx:page-loading-stop", info => topbar.hide())

liveSocket.connect()

window.liveSocket = liveSocket

document.addEventListener('DOMContentLoaded', function() {
  const flatpickr_config = {
    altInput: true,
    dateFormat: 'Y-m-d',
    altFormat: 'n/j/Y',
    allowInput: true,
    shorthandCurrentMonth: true,
    wrap: true
  };

  flatpickr('div.datepicker', flatpickr_config);

}, false);
